var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBerryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.43 32.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6511f5;}.cls-1,.cls-2,.cls-3{stroke:#231f20;stroke-miterlimit:10;}.cls-2{fill:#80c68b;}.cls-3{fill:#12ce60;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 16.18,
    cy: 16.94,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20.3,
    cy: 13.93,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 15.46,
    cy: 10.03,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20.79,
    cy: 21.8,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 15.46,
    cy: 23.57,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 10.26,
    cy: 19.17,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 11.63,
    cy: 12.72,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 8.36,
    cy: 9.72,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 5.24,
    cy: 15.14,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 4.53,
    cy: 21.44,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 9.84,
    cy: 26.39,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 4.05,
    cy: 28.32,
    rx: 3.55,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,7.61a7.7,7.7,0,0,0,5.6-1.81A8,8,0,0,0,28.9.5a8.64,8.64,0,0,1-2.4,5.15A8.45,8.45,0,0,1,21,7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.72,16.2c.25-.41,2-3.4.76-6.45-.86-2.1-3.09-4.08-4.39-3.55s-1.57,3.72-.7,6A7.46,7.46,0,0,0,30.72,16.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerryLogo);
export default __webpack_public_path__ + "static/media/berry-logo.6df3a53fbc2a0db17019199f217e1797.svg";
export { ForwardRef as ReactComponent };